module.exports = __webpack_public_path__ + "img/65.334c627c.jpg";